var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",staticClass:"marketing-iframe",attrs:{"src":_vm.block.src},on:{"load":_vm.resizeIFrameToFitContent}})}
var staticRenderFns = []

export { render, staticRenderFns }